import { $Q } from './querySelector';

/**
 * Binds a click to two 'a' elements. One located in the login form and the other one
 * located in the forgot-password form.
 *
 * Clicking on the first slides the forgot-password form into view
 * Clicking on the last one slides the login form into view
 *
 * It also detects if the url comes with '#recover' included and if it does, the forgot-password
 * slides into view on load
 */
document.addEventListener('DOMContentLoaded', () => {
  const $formContainer = $Q('.customer-form-container');

  if (window.location.href.includes('#recover')) {
    if (!$formContainer.classList.contains('recover-shown')) {
      $formContainer.classList.add('recover-shown');
    }
  }

  if ($formContainer) {
    $Q('#recover-link').addEventListener('click', () => {
      $formContainer.classList.add('recover-shown');
    });

    $Q('#goto-login').addEventListener('click', () => {
      $formContainer.classList.remove('recover-shown');
    });
  }
});